import { getStationStatus } from '../components/molecules/MapFilter/tools';

function getMarkers(chargePoints) {
  const { chargePointList } = chargePoints;

  return chargePointList
    // MV2-1680: dashboard mantém a estação na LISTAGEM (pra permitir editar) mesmo que
    // todos os conectores dela estejam Oculto — o backend já removeu os conectores HIDDEN
    // do array. Aqui no mapa, sem conector visível não faz sentido mostrar marker.
    .filter((chargePoint) => chargePoint.connectors && chargePoint.connectors.length > 0)
    .map((chargePoint) => ({
      pk: chargePoint.chargeBoxPk,
      name: chargePoint.chargeBoxId,
      title: chargePoint.description,
      position: {
        lat: chargePoint.locationLatitude,
        lng: chargePoint.locationLongitude,
      },
      icon: {
        url:
          chargePoint.origin === 'PLUG_SHARE'
            ? require('../assets/lightBluePoint.png')
            : getStationMarkerIconColor(chargePoint),
      },
      connectors: chargePoint.connectors,
      origin: chargePoint.origin,
    }))
    .filter(({ position }) => position?.lat && position?.lng);
}

function getStationMarkerIconColor(chargePoint) {
  let chargerStatus = getStationStatus(chargePoint);

  switch (chargerStatus.status) {
    case 'orange':
      return require('../assets/orangePoint.png');
    case 'green':
      return require('../assets/greenPoint.png');
    case 'gray':
      return require('../assets/grayPoint.png');
    case 'darkBlue':
      return require('../assets/darkBluePoint.png');
    default:
      return require('../assets/grayPoint.png');
  }
}

export { getMarkers };
